// extracted by mini-css-extract-plugin
export default {"root":"ExpandIcon_root__6IF2i","icon":"ExpandIcon_icon__xwez7"};